import { App } from 'antd';
import { useCallback, useEffect } from 'react';

import { credentialsActions } from '@store/credentials/credentials.slice';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useAddCredentialMutation } from '@hook/credential/credential.hooks';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { AddCredentialRequestInterface } from '@interface/credential/credential.interface';

export const useNewCredential = () => {
  const { current } = useCurrentApplication();
  const { action, state } = useMutation(
    useAddCredentialMutation(),
    credentialsActions,
    credentialsActions.setCredential,
  );
  const { message } = App.useApp();
  const { isViewer } = useMemberRole();

  useEffect(
    () => void (state.isSuccess && message.success('Credentials was successfully added')),
    [state.isSuccess, message],
  );

  const onAdd = useCallback(
    () => action({ application: current.id } as AddCredentialRequestInterface),
    [current, action],
  );

  return {
    onAdd,
    isLoading: state.isLoading,
    shouldEdit: !isViewer,
  };
};
